// extracted by mini-css-extract-plugin
export var questionBox = "_9z-0";